export class CostDataRecordDimensions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "product",
            "baseName": "product",
            "type": "CostProduct",
            "format": ""
        },
        {
            "name": "usageType",
            "baseName": "usageType",
            "type": "UsageType",
            "format": ""
        },
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "resourceType",
            "baseName": "resourceType",
            "type": "ResourceType",
            "format": ""
        },
        {
            "name": "resourceId",
            "baseName": "resourceId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "sourceAccountProviderId",
            "baseName": "sourceAccountProviderId",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountId",
            "baseName": "sourceAccountId",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "sourceAccountName",
            "baseName": "sourceAccountName",
            "type": "string",
            "format": ""
        },
        {
            "name": "sourceAccountTags",
            "baseName": "sourceAccountTags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "sourceStorageSize",
            "baseName": "sourceStorageSize",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "providerResourceId",
            "baseName": "providerResourceId",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceName",
            "baseName": "resourceName",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceTags",
            "baseName": "resourceTags",
            "type": "{ [key: string]: string; }",
            "format": ""
        },
        {
            "name": "resourceSourceRegion",
            "baseName": "resourceSourceRegion",
            "type": "string",
            "format": ""
        },
        {
            "name": "vaultId",
            "baseName": "vaultId",
            "type": "string",
            "format": ""
        },
        {
            "name": "dsgBucket",
            "baseName": "dsgBucket",
            "type": "string",
            "format": ""
        },
        {
            "name": "dsgEnvironment",
            "baseName": "dsgEnvironment",
            "type": "string",
            "format": ""
        },
        {
            "name": "dsgStorageTier",
            "baseName": "dsgStorageTier",
            "type": "DsgStorageTier",
            "format": ""
        },
        {
            "name": "dsgRequestType",
            "baseName": "dsgRequestType",
            "type": "DsgRequestType",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return CostDataRecordDimensions.attributeTypeMap;
    }
    constructor() {
    }
}
